var _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefaultCar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ic-round-car",
    xmlns: "http://www.w3.org/2000/svg",
    width: 172,
    height: 172,
    viewBox: "0 0 172 172",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_149",
    "data-name": "Ellipse 149",
    cx: 86,
    cy: 86,
    r: 86,
    fill: "#444"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic-car",
    transform: "translate(31 46)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "car-solid",
    d: "M107.414,87.366H94.552l-3.575-8.679A23.944,23.944,0,0,0,68.64,64H41.357a23.952,23.952,0,0,0-22.34,14.687l-3.575,8.679H2.583a2.52,2.52,0,0,0-2.5,3.111l1.289,5.007a2.563,2.563,0,0,0,2.5,1.9H8.183A13.1,13.1,0,0,0,3.44,107.393v10.014a13.029,13.029,0,0,0,3.437,8.747v11.28a6.778,6.778,0,0,0,6.874,6.676h6.874a6.778,6.778,0,0,0,6.874-6.676v-6.676h55v6.676a6.778,6.778,0,0,0,6.874,6.676h6.874a6.778,6.778,0,0,0,6.874-6.676v-11.28a13.021,13.021,0,0,0,3.437-8.747V107.393a13.109,13.109,0,0,0-4.741-10.014h4.312a2.563,2.563,0,0,0,2.5-1.9l1.289-5.007A2.523,2.523,0,0,0,107.414,87.366Zm-75.632-3.72a10.315,10.315,0,0,1,9.575-6.294H68.64a10.315,10.315,0,0,1,9.575,6.294l4.281,10.4h-55Zm-11.156,33.72c-4.125,0-6.874-2.662-6.874-6.655s2.75-6.655,6.874-6.655,10.312,5.99,10.312,9.983S24.751,117.365,20.626,117.365Zm68.745,0c-4.125,0-10.312.666-10.312-3.328s6.187-9.983,10.312-9.983,6.874,2.662,6.874,6.655S93.5,117.365,89.371,117.365Z",
    transform: "translate(-0.004 -64)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultCar);
export default __webpack_public_path__ + "static/media/defaultCar.8e664436d1a47c977b6bab226be3d0d1.svg";
export { ForwardRef as ReactComponent };